import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import SignInScreen from './pages/SignInScreen';
import MainChatInterface from './layouts/MainChatInterface';
import SubscriptionScreen from './components/subscription/SubscriptionScreen';
import LandingPage from './pages/LandingPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import StatusHealth from './StatusHealth';
import AdminModelsPage from './pages/AdminModelsPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminGivingPage from './pages/AdminGivingPage';
import GlobalTitleTooltip from './components/ui/GlobalTitleTooltip';
import { capturePageView, identifyPostHogUser, resetPostHogUser } from './analytics/posthog';
import './fonts.css';
import 'katex/dist/katex.min.css';

const RouteAnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    capturePageView(location);
  }, [location]);

  return null;
};

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log('App component mounted');

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      if (user) {
        identifyPostHogUser(user);
      } else {
        resetPostHogUser();
      }
      setLoading(false);
    }, (error) => {
      console.error('Auth error:', error);
      setError(error);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <Router>
      <GlobalTitleTooltip />
      <RouteAnalyticsTracker />
      <Routes>
        <Route
          path="/welcome"
          element={
            user ? (
              <Navigate to="/chat" replace />
            ) : (
              <LandingPage />
            )
          }
        />
        <Route
          path="/"
          element={
            user ? (
              <Navigate to="/chat" replace />
            ) : (
              <LandingPage />
            )
          }
        />
        <Route
          path="/chat"
          element={
            user ? (
              <MainChatInterface />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/subscribe"
          element={
            user ? (
              <SubscriptionScreen />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/login"
          element={
            user ? (
              <MainChatInterface />
            ) : (
              <SignInScreen/>
            )
          }
        />
        <Route
          path="/signin"
          element={
            user ? (
              <MainChatInterface />
            ) : (
              <SignInScreen/>
            )
          }
        />
        <Route
          path="/signup"
          element={
            user ? (
              <MainChatInterface />
            ) : (
              <SignInScreen/>
            )
          }
        />
        <Route
          path="/landing"
          element={ <LandingPage /> }
        />
        <Route
          path="/status-health"
          element={ <StatusHealth /> }
        />
        <Route
          path="/status"
          element={ <StatusHealth /> }
        />
        <Route
          path="/privacy"
          element={ <PrivacyPolicy /> }
        />
        <Route
          path="/terms"
          element={ <TermsAndConditions /> }
        />
        <Route
          path="/admin/models"
          element={
            user ? (
              <AdminModelsPage />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/admin/dashboard"
          element={
            user ? (
              <AdminDashboardPage />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/admin/giving"
          element={
            user ? (
              <AdminGivingPage />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
